/* globals */

import httpClient from './lib/httpClient'

export const insertPet = async (ownerId, payload) => {
  const endpoint = '/api/Pet/insert/?ownerId=' + ownerId
  return httpClient.post(endpoint, payload)
}

export const updatePet = async (payload) => {
  const endpoint = '/api/Pet/update'
  return httpClient.post(endpoint, payload)
}

export const getPet = async (petId) => {
  const endpoint = '/api/Pet/?petId=' + petId
  return httpClient.get(endpoint)
}

export const getHistory = async (petId) => {
  const endpoint = '/api/Pet/getAppointments/?petId=' + petId
  return httpClient.get(endpoint)
}

export default {
  insertPet,
  updatePet,
  getPet,
  getHistory
}
